import { forwardRef } from "react";
import { Input } from "antd";
import classNames from "classnames";
import type { InputRef, InputProps } from "antd/lib/input";
import styles from "./styles.module.scss";

export const AppInput = forwardRef<InputRef, InputProps>(({ className, ...props }, ref) => {
  return <Input ref={ref} className={classNames(styles.input, className)} {...props} />;
});
